import React from "react";
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
} from "../../components/ui/dialog";
import { Teacher } from "../../api/teachers";
import { Badge } from "../../components/ui/badge";
import { Mail, Phone, BookOpen, Briefcase } from "lucide-react";

interface ViewProfessorProps {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    professor: Teacher | null;
}

const ViewProfessor: React.FC<ViewProfessorProps> = ({
    open,
    onOpenChange,
    professor,
}) => {
    if (!professor) return null;

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="sm:max-w-[500px]">
                <DialogHeader>
                    <DialogTitle>Détails du professeur</DialogTitle>
                </DialogHeader>
                <div className="space-y-6">
                    <div className="grid gap-4 py-4">
                        <div className="flex items-center gap-4">
                            <div className="h-16 w-16 rounded-full bg-primary/10 flex items-center justify-center text-2xl font-bold text-primary">
                                {professor.firstName[0]}
                                {professor.lastName[0]}
                            </div>
                            <div>
                                <h3 className="text-xl font-semibold">
                                    {professor.firstName} {professor.lastName}
                                </h3>
                                <p className="text-sm text-muted-foreground">
                                    {professor.specialization || "Aucune spécialisation"}
                                </p>
                            </div>
                        </div>

                        <div className="grid gap-2">
                            <div className="flex items-center gap-2 text-sm">
                                <Mail className="h-4 w-4 text-muted-foreground" />
                                <span>{professor.email}</span>
                            </div>
                            <div className="flex items-center gap-2 text-sm">
                                <Phone className="h-4 w-4 text-muted-foreground" />
                                <span>{professor.phone}</span>
                            </div>
                            <div className="flex items-center gap-2 text-sm">
                                <Briefcase className="h-4 w-4 text-muted-foreground" />
                                <span>
                                    Inscrit le {new Date(professor.createdAt).toLocaleDateString()}
                                </span>
                            </div>
                        </div>
                    </div>

                    <div className="space-y-3">
                        <h4 className="text-sm font-medium flex items-center gap-2">
                            <BookOpen className="h-4 w-4" /> Cours enseignés
                        </h4>
                        {professor.courses && professor.courses.length > 0 ? (
                            <div className="flex flex-wrap gap-2">
                                {professor.courses.map((course) => (
                                    <Badge key={course.id} variant="secondary">
                                        {course.name} ({course.code})
                                    </Badge>
                                ))}
                            </div>
                        ) : (
                            <p className="text-sm text-muted-foreground italic">
                                Aucun cours assigné pour le moment.
                            </p>
                        )}
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default ViewProfessor;
